module.exports = __webpack_public_path__ + "media/images/footer_logo-63ee3b46a61aced952592c8350fcf8f9.png";